// routes/_home.tsx
import { useEffect, useState } from "react"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import Cookies from "js-cookie"

import { fetchAndSaveUserProfile } from "@/lib/api/auth"
import { isAuthenticated, isHimoAssistantEnabled } from "@/lib/auth"
import { SidebarProvider } from "@/components/ui/sidebar"
import { ChatHead } from "@/components/chat/chat-head"
import { useEmbed } from "@/components/context/embed-context"
import { ThemeProvider } from "@/components/context/theme-provider"
import { AppSidebar } from "@/components/layout/app-sidebar"

export const Route = createFileRoute("/_home")({
  beforeLoad: async ({ location }) => {
    const authenticated = await isAuthenticated()
    if (!authenticated) {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
      })
    }
  },
  component: HomeLayout,
})

function HomeLayout() {
  const { isEmbed } = useEmbed() // ⬅️ gamitin ang context
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (isEmbed) {
      console.log("isEmbed: ", isEmbed)

      fetchAndSaveUserProfile()
        .catch((err) => console.error("Failed to load user profile", err))
        .finally(() => setIsLoading(false))
    } else {
      if (!Cookies.get("user_info")) {
        fetchAndSaveUserProfile()
          .catch((err) => console.error("Failed to load user profile", err))
          .finally(() => setIsLoading(false))
      } else {
        setIsLoading(false)
      }
    }
  }, [isEmbed])

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <SidebarProvider>
        {/* <AppSidebar /> */}
        {!isEmbed && <AppSidebar />}
        <div className="w-full">
          <Outlet />
        </div>
        {!isEmbed && isHimoAssistantEnabled() && <ChatHead />}
      </SidebarProvider>
    </ThemeProvider>
  )
}
